/**
 * Module-level registry for the leave-booking modal opener. The app shell
 * registers a function on mount; any component (including dashboard cards
 * that don't receive `view` as a prop) can call `openLeaveBooking()` to
 * trigger the centralized modal.
 */
type Opener = (options?: {
    onSuccess?: () => void
    /** Book on behalf of someone else (manager/admin) — omit for self. */
    targetEmployee?: { id: number; name: string }
    /** Prefill the period ('YYYY-MM-DD'), e.g. from a calendar click/drag. */
    initialRange?: { start: string; end: string }
}) => void

let opener: Opener | null = null

export const registerLeaveBookingOpener = (fn: Opener | null): void => {
    opener = fn
}

export const openLeaveBooking = (options?: Parameters<Opener>[0]): void => {
    opener?.(options)
}
